import React from 'react';
import { Divider as MuiDivider } from '@mui/material';

export const Divider = () => <MuiDivider variant="middle" />;
